var _defs, _path, _path2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: .6px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 23.107 24.959 L 23.107 11.159 C 23.107 9.259 21.607 7.759 19.707 7.759 C 17.807 7.759 16.307 9.259 16.307 11.159 L 16.307 24.959 C 14.107 26.859 13.907 30.159 15.807 32.359 C 16.807 33.459 18.207 34.159 19.707 34.159 C 22.607 34.159 25.007 31.759 25.007 28.859 C 25.007 27.359 24.307 25.859 23.207 24.859 M 22.907 32.159 C 22.007 33.059 20.907 33.459 19.707 33.459 C 17.207 33.459 15.207 31.359 15.207 28.859 C 15.207 27.559 15.807 26.259 16.907 25.359 C 16.907 25.359 17.007 25.159 17.007 25.059 L 17.007 11.059 C 17.007 9.559 18.307 8.359 19.707 8.359 C 21.207 8.359 22.307 9.559 22.407 11.059 L 22.407 25.059 C 22.407 25.159 22.407 25.259 22.507 25.359 C 24.407 26.959 24.707 29.759 23.207 31.759 C 23.107 31.859 23.007 32.059 22.907 32.159"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 21.807 26.259 L 21.307 25.859 L 21.307 11.859 L 18.107 11.859 L 18.107 25.859 L 17.607 26.259 C 16.107 27.459 15.907 29.559 17.107 31.059 C 17.707 31.859 18.707 32.359 19.707 32.359 C 21.607 32.359 23.107 30.859 23.107 28.959 C 23.107 27.059 22.607 26.959 21.807 26.259"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.907,
    y: 21.659,
    width: 3.1,
    height: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.907,
    y: 19.159,
    width: 2.6,
    height: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.907,
    y: 16.559,
    width: 3.1,
    height: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.402a8e12a544758b2dcf9857b843a45f.svg";
export { ForwardRef as ReactComponent };